import { nestApiClient } from './api-client';
import {
  LatestStepUpResponse,
  StepupLaunchHistory,
  StepupResponse,
  StepupUserStatus,
} from '@wwe-portal/entities/stepup.type';

export const getLatestStepup = () => {
  return nestApiClient.get<LatestStepUpResponse>('/v1/steps-up-offers/latest');
};

export const getStepup = (id: string) => {
  return nestApiClient.get<StepupResponse>(`/v1/steps-up-offers/${id}`);
};

export const getStepupUserStatus = (id: string) => {
  return nestApiClient.get<StepupUserStatus>(
    `/v1/steps-up-offers/${id}/status`
  );
};

export const getAllStepup = () => {
  return nestApiClient.get<{ data: string[] }>('/v1/steps-up-offers/offers-id');
};

export const getStepupLaunchHistory = (stepsUpId: string) => {
  return nestApiClient.get<{ data: StepupLaunchHistory | undefined }>(
    `/v1/steps-up-offers/${stepsUpId}/launch-popup-history`
  );
};

export const postStepupTime = async (stepsUpId: number) => {
  return nestApiClient.post<LatestStepUpResponse>(
    `/v1/steps-up-offers/${stepsUpId}/launch-popup-history`
  );
};

interface StepupOfferMutationPayload {
  stepupId: string;
  offerId: string;
  orderId: number;
}

interface StepupOfferMutationResponse {
  data: { success: boolean; message: string };
}

export const validateStepupOffer = ({
  stepupId,
  orderId,
  offerId,
}: StepupOfferMutationPayload) => {
  return nestApiClient.post<StepupOfferMutationResponse>(
    `/v1/steps-up-offers/${stepupId}/validate`,
    {
      offerId,
      orderId,
    }
  );
};

export const purchaseStepupOffer = ({
  stepupId,
  offerId,
  orderId,
}: StepupOfferMutationPayload) => {
  return nestApiClient.post<StepupOfferMutationResponse>(
    `/v1/steps-up-offers/${stepupId}/purchase`,
    {
      offerId,
      orderId,
    }
  );
};
